var AUTH0_CLIENT_ID;
var AUTH0_DOMAIN;
var AUTH0_CUSTOM_DOMAIN;
var AUTH0_CDN_BASE;
var AUTH0_CALLBACK_URL=window.location.href;
var AUTH0_AUDIENCE='audience';
var REQUESTED_SCOPES='openid email write:training';
// needed for numbers service
var AUTH0_WHITELISTED_DOMAINS=[
    'http://127.0.0.1:8000'
];
